import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotifications } from "../redux/slices/notificationSlice";
import { FaRegBell } from "react-icons/fa";

const AdminNotificationBell = () => {

    const dispatch = useDispatch();
    const { items = [] } = useSelector((state) => state.notifications);

    // unread count
    const unreadCount = items.filter((n) => !n.isRead).length;

    useEffect(() => {
        dispatch(fetchNotifications({ role: "admin", page: 1, limit: 10 }));

        const interval = setInterval(() => {
            dispatch(fetchNotifications({ role: "admin", page: 1, limit: 10 }));
        }, 10000);

        return () => clearInterval(interval);
    }, [dispatch]);

    return (
        <div className="position-relative">
            <FaRegBell size={24} className="text-dark" />
            {unreadCount > 0 && (
                <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: "0.75rem" }}
                >
                    {unreadCount}
                </span>
            )}
        </div>
    );
};

export default AdminNotificationBell;
